var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"text-xs"},[_c('strong',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "+_vm._s(_vm.value ? _vm.value : 'n/a')+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }